export const MY_CLIENTS_PAGE_VIEWED =
  'app/containers/MyClientsGrouped/MY_CLIENTS_PAGE_VIEWED';
export const TTA_CLIENTS_CARD_CLICKED =
  'app/containers/MyClientsGrouped/TTA_CLIENTS_CARD_CLICKED';
export const CLIENTS_SCHEDULED_VISIT_CARD_CLICKED =
  'app/containers/MyClientsGrouped/CLIENTS_SCHEDULED_VISIT_CARD_CLICKED';
export const CLIENTS_PROPOSAL_STAGE_CARD_CLICKED =
  'app/containers/MyClientsGrouped/CLIENTS_PROPOSAL_STAGE_CARD_CLICKED';
